import { render, staticRenderFns } from "./bm4000-module.vue?vue&type=template&id=1daa91b2"
import script from "./bm4000-module.vue?vue&type=script&lang=js"
export * from "./bm4000-module.vue?vue&type=script&lang=js"
import style0 from "./bm4000-module.vue?vue&type=style&index=0&id=1daa91b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports